import { filterByObjectValues } from './filterByObjectValues'
import { order } from './order'

const filterByStatus = (triaging: Triage[], status: string | null = null) => {
  if (!status) return triaging
  const byStatus = (item: Triage) =>
    item.status.toLowerCase() === status.toLowerCase()

  return triaging?.filter(byStatus)
}

const filterBySearch = (
  triaging: Triage[],
  search: string | null = null,
): Triage[] => {
  if (!search) return triaging
  const keys = ['customerName', 'customerTaxDocument', 'status']

  return filterByObjectValues<Triage>(triaging, keys, search)
}

const filterTriage = ({
  triage,
  search,
  status,
  orderBy,
  orientation,
}: {
  triage: Triage[]
  search?: string | null
  status?: string | null
  orderBy?: string | null
  orientation?: string | null
}): Triage[] => {
  const filteredByStatus = filterByStatus(triage, status?.toLowerCase())
  const filteredBySearch = filterBySearch(filteredByStatus, search)

  const safeOrderBy = orderBy || ''
  const safeOrientation = orientation || ''

  if (!safeOrderBy && !safeOrientation) return filteredBySearch
  return order(filteredBySearch, safeOrderBy, safeOrientation)
}

export { filterTriage, filterByStatus }
